import {DateFormat} from "../../date_format"
import messageResource from "../../messageResource"
import ChartPDFDateRangeFormattingStrategy from '../formatters/ChartPDFDateRangeFormattingStrategy'

export default class PDFParametersFormattingStrategy {
    init(config) {
        this.productSettingsValidator = config.productSettingsValidator;
        this.reportRightsValidator = config.reportRightsValidator;
        this.dateParametersFormattingStrategy = this.createDateParametersFormattingStrategy(config.dateFormat, config.dateFormatForFile);
        this.reportParamsStringBuilder = new config.reportParamsStringBuilderConstructor({
            data: {
                users: config.users,
                userGroupsFeatureEnabled: !_.isNull(config.userGroups) && this.productSettingsValidator.isUGREnabled(),
                tzGroupsFeatureEnabled: !_.isNull(config.timeZoneGroups) && this.productSettingsValidator.isTZGEnabled(),
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                leaveTypesMap: config.leaveTypesMap,
                manageableUserIds: config.manageableUserIds,
                projectsWithMaIds: config.projectsWithMaIds,
            },
            dateFormat: config.dateFormat,
            reportAuthorizationInfo: config.reportAuthorizationInfo,
        })

        this.shortDateFormat = new DateFormat(window.SystemSettings.dateFormat);
        return this;
    }

    createDateParametersFormattingStrategy(dateFormat, dateFormatForFile)
    {
        return new ChartPDFDateRangeFormattingStrategy(dateFormat, dateFormatForFile)
    }

    formatChartPDFFilterInformation(selectedParameters, assignedInfo)
    {
        return {
            firstRow: this.formatUsersSelection(selectedParameters.userSelection, assignedInfo),
            secondRow: this.formatLeaveTypesSelection(selectedParameters.leaveTypeSelection)
        }
    }

    formatUsersSelection(userSelection, assignedInfo)
    {
        return this.reportParamsStringBuilder.getUserSelectionParamString(userSelection, assignedInfo);
    }

    formatLeaveTypesSelection(leaveTypeSelection)
    {
        return this.reportParamsStringBuilder.getLeaveTypeSelectionParamString(leaveTypeSelection);
    }

    formatChartPDFHeaderDateInformation(selectedParameters)
    {
        return this.dateParametersFormattingStrategy.formatDateInformation(selectedParameters);
    }

    formatChartPDFFileName(selectedParameters)
    {
        var dateRange = selectedParameters.dateRangeSelection;
        var formattedDateRange = "(" + this.shortDateFormat.formatDate(dateRange.fromDate) + " - " + this.shortDateFormat.formatDate(dateRange.toDate) + ")";

        var fileNameParts = [];
        fileNameParts.push(this._makePDFTitle('common.leave.reports.pdf.header.and'));
        fileNameParts.push(formattedDateRange);

        return messageResource.getMessage('common.leave.reports.pdf.file_name', fileNameParts);
    }

    _makePDFTitle(andSubstitutionKey)
    {
        andSubstitutionKey = _.isUndefined(andSubstitutionKey) ? 'common.leave.reports.pdf.header.amp' : andSubstitutionKey;
        var andMessage = messageResource.getMessage(andSubstitutionKey);

        var enabledPTO =  this.productSettingsValidator.isPTOEnabled();
        var enabledSick =  this.productSettingsValidator.isSickEnabled();

        if (!this.reportRightsValidator.isCanViewBalances() || (!enabledPTO && !enabledSick))
            return messageResource.getMessage('common.leave.reports.pdf.header.leave_time');

        var balanceMessage = andMessage + " " + this.reportParamsStringBuilder.getBalancesParamString(enabledPTO, enabledSick);
        return messageResource.getMessage('common.leave.reports.pdf.header.leave_time_and_balances', [balanceMessage]);
    }

    formatChartPDFHeaderTitle(selectedParameters)
    {
        return messageResource.getMessage('common.leave.reports.pdf.header.report', [this._makePDFTitle()]);
    }

    formatChartPDFReportTitle(selectedParameters)
    {
        var showBy = LeavesReportFormatUtils.formatGroupingLevel(selectedParameters.firstGroupingLevel);
        return messageResource.getMessage('common.leave.reports.pdf.header.report_by', [this._makePDFTitle(), showBy]);
    }
}


// WEBPACK FOOTER //
// ./web/js/pdf/leavesReport/PDFParametersFormattingStrategy.js